import { Navigate, useParams } from "react-router-dom";

export const OrderRedirect = ( ) => {
    let params = useParams();
    const orderNo= params.orderno;
    console.log("Here is the order no:", orderNo);
    // const navigate = useNavigate();
    return(<Navigate replace to={`/inventory/vmi/orders/${orderNo}`}/>)
}